import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      stroke-width={2}
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Z"
    />
    <path
      fill="currentColor"
      d="M16.2 9.717a.663.663 0 0 1 .736.377.69.69 0 0 1 .064.293.704.704 0 0 1-.166.44.69.69 0 0 1-.406.234c-.953.176-1.915.296-2.88.357a.445.445 0 0 0-.318.165.468.468 0 0 0-.103.254l-.002.039.004.06.08.742c.103.912.29 1.813.56 2.686l.105.326.113.327.528 1.433a.683.683 0 0 1-.18.735.651.651 0 0 1-.218.132.664.664 0 0 1-.242.047.663.663 0 0 1-.523-.272l-.044-.07-.033-.063-.133-.292a46.49 46.49 0 0 1-1-2.349L12 14.954l-.182.47c-.1.252-.2.503-.305.754l-.159.375-.244.56-.252.555-.12.247a.664.664 0 0 1-1.24.042.68.68 0 0 1-.052-.366l.015-.08.02-.07.528-1.431c.312-.862.542-1.752.685-2.656l.05-.34.042-.345.085-.737a.478.478 0 0 0-.102-.356.456.456 0 0 0-.317-.166 24.11 24.11 0 0 1-2.904-.362.667.667 0 0 1-.534-.527.677.677 0 0 1 .09-.506.67.67 0 0 1 .425-.296.659.659 0 0 1 .263-.002c2.78.522 5.63.521 8.406 0Zm-5.394-3.578a1.668 1.668 0 0 1 2.384 0 1.727 1.727 0 0 1 0 2.414 1.668 1.668 0 0 1-2.384 0 1.727 1.727 0 0 1 0-2.414Z"
    />
  </svg>
);
export const A11YIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
